/* eslint-disable react/jsx-pascal-case */
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getMABAA080, getMABAA080Cancel, postMABAA080Recruit } from '../../../services/Api';
import { formatDate, formatDateTime, formatNumberWithCommas, getImageSrc } from '../../../utils';
import PopupMABAA080_1 from './popupMABAA080_1';
import PopupMABAA080_2 from './popupMABAA080_2';
import PopupMABAA080_3 from './popupMABAA080_3';
import PopupMABAA080_4 from './popupMABAA080_4';
import PopupMABAA080_5 from './popupMABAA080_5';
import PopupMABAA080_6 from './popupMABAA080_6';
import PopupMABAA080_7 from './popupMABAA080_7';
import PopupMABAA080_8 from './popupMABAA080_8';
import PopupMABAA080_9 from './popupMABAA080_9';
const MABAA080 = () => {
    const { id } = useParams();
    const [dataInfo, setDataInfo] = useState([]);
    const [dataPayment, setDataPayment] = useState([]);
    const [dataRecruit, setDataRecruit] = useState([]);
    const [dataRecruitHist, setDataRecruitHist] = useState([]);
    const [dataBanner, setDataBanner] = useState([]);
    const [totalTotPrice, setTotalTotPrice] = useState(0);
    const [totalCancel, setTotalCancel] = useState(0);
    const [totalSuccessPayment, setTotalSuccessPayment] = useState(0);

    const [isPopupOpen, setIsPopupOpen] = useState('');

    const popupComponents = {
        popupMABAA080_1: PopupMABAA080_1,
        popupMABAA080_2: PopupMABAA080_2,
        popupMABAA080_3: PopupMABAA080_3,
        popupMABAA080_4: PopupMABAA080_4,
        popupMABAA080_5: PopupMABAA080_5,
        popupMABAA080_6: PopupMABAA080_6,
        popupMABAA080_7: PopupMABAA080_7,
        popupMABAA080_8: PopupMABAA080_8,
        popupMABAA080_9: PopupMABAA080_9,
    };

    const ActivePopup = isPopupOpen ? popupComponents[isPopupOpen.popupName] : null;

    const getPaymentMethod = (payMethod) => {
        switch (payMethod) {
            case 'Card':
                return '신용카드';
            case 'VCard':
                return '신용카드';
            case 'VBank':
                return '가상계좌';
            case 'EMTICKET':
                return 'Dvmall 이용권';
            case 'DirectBank':
                return '계좌이체';
            default:
                return '';
        }
    };

    const getStatusText = (flag, recruitEnd, recruitFrom) => {
        const currentDate = moment().format('YYYY-MM-DD');
        switch (flag) {
            case 'K':
                return '보관'; // #698c81
            case 'O':
                if (recruitEnd < currentDate) {
                    return '기간마감(시스템)'; // #a0a0a0
                } else if (recruitEnd >= currentDate) {
                    return '게재중'; // #ff6600
                } else if (recruitFrom > currentDate) {
                    return '등록대기'; // #336633
                }
                return '';
            case 'C':
                return '채용마감(회원)'; // #a0a0a0
            case 'E':
                return '기간마감(시스템)'; // #698c81
            case 'D':
                return '삭제'; // #6b738c
            case 'P':
                return '입금대기'; // #2178aa
            case 'V':
                return '승인대기'; // #c79b01
            case 'W':
                return '등록대기'; // #336633
            case 'X':
                return '미결제삭제'; // #6b738c
            case 'J':
                return '승인거절'; //  #6b738c
            case 'N':
                return '입금기한만료'; //  #6b738c
            default:
                return '';
        }
    };

    const selectStatusColor = (key, recruitEnd) => {
        const currentDate = moment().format('YYYY-MM-DD');
        recruitEnd = moment(recruitEnd).format('YYYY-MM-DD');
        switch (key) {
            case 'K':
                return '#698c81';
            case 'O':
                if (recruitEnd < currentDate) {
                    return '#a0a0a0';
                } else if (recruitEnd >= currentDate) {
                    return '#ff6600';
                }
                return '';
            case 'C':
                return '#a0a0a0';
            case 'E':
                return '#698c81';
            case 'D':
                return '#6b738c';
            case 'P':
                return '#2178aa';
            case 'V':
                return '#c79b01';
            case 'W':
                return '#336633';
            case 'X':
                return '#6b738c';
            case 'J':
                return '#6b738c';
            default:
                return '#000000'; // Default color
        }
    };

    const fetchRecruitData = async (memberID) => {
        try {
            const { data: recruitData } = await postMABAA080Recruit(memberID);
            setDataRecruit(recruitData.recruit);
            setDataRecruitHist(recruitData.recruitHist);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchData = async () => {
        try {
            const { data } = await getMABAA080(id);
            setDataInfo(data.info[0]);
            setDataPayment(data.hisPayment);
            setDataBanner(data.banners);

            const total = data?.hisPayment?.reduce((total, item) => total + (item?.totPrice || 0), 0);

            const totalCancel = data?.hisPayment?.filter((item) => item.cancelFlag === 'Y').length;
            setTotalCancel(totalCancel);

            const totalSuccess = data?.hisPayment?.filter((item) => item.resultCode === '00').length;
            setTotalSuccessPayment(totalSuccess);
            setTotalTotPrice(total);
            if (data?.info[0].memberID && !isPopupOpen) {
                fetchRecruitData(data.info[0].memberID);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (id && !isPopupOpen) {
            fetchData();
        }
        // eslint-disable-next-line
    }, [id, isPopupOpen]);

    const handleCancelRecruit = (memberID, seq) => {
        const isConfirm = window.confirm('승인취소하시겠습니까?');
        if (isConfirm) {
            getMABAA080Cancel({
                params: {
                    memberID,
                    seq,
                },
            })
                .then(() => {
                    alert('승인취소되었습니다.');
                    fetchData();
                })
                .catch((error) => console.log(error));
        }
    };

    const handleOpenPopup = (popupName, additionalData) => {
        setIsPopupOpen({ popupName, additionalData });
    };

    const isValidDate = (date) =>
        date && !date.startsWith('1900-01-01');

    return (
        <>
            <div className="profile-content">
                <div className="title-profile">채용광고 내역</div>
                <div className="profile-information">
                    <div className="profile-information-left">
                        <div className="room-name">{dataInfo?.bizCompany}</div>
                        <div className="room-image">
                            {dataInfo.avatar && dataInfo.avatar !== '' ? (
                                <img src={getImageSrc('recruit_logo', dataInfo.avatar)} alt="Recruit Logo" />
                            ) : (
                                <img src="./images/default_logo.png" alt="Default Logo" />
                            )}
                        </div>
                    </div>
                    <div className="profile-information-right">
                        <ul>
                            <li>
                                <div className="representative-label">대표자명:</div>
                                <div className="representative-name">{dataInfo?.nameKor}</div>
                            </li>
                            {dataInfo?.bizNo !== '' && (
                                <li>
                                    <div className="business-number-label">사업자 번호:</div>
                                    <div className="business-number">{dataInfo?.bizNo}</div>
                                </li>
                            )}
                            <li>
                                <div className="phone-number-label">대표자 연락처:</div>
                                <div className="phone-number">{dataInfo?.telNo}</div>
                            </li>
                            <li>
                                <div className="mail-address-label">이메일 주소:</div>
                                <div className="mail-address">{dataInfo?.email}</div>
                            </li>
                            <li>
                                <div className="address-label">주소:</div>
                                <div className="address">
                                    ({dataInfo?.postNo}) {dataInfo?.addressRoad}
                                    {dataInfo?.addressDetail || dataInfo?.addressDetail !== ''
                                        ? `, ${dataInfo?.addressDetail}`
                                        : ''}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div id="profile-payment-details">
                    <div className="title-table">
                        결제 내역 <small className="blue">* 최근 3개월간 결제 내역 확인 가능합니다.</small>
                    </div>

                    <table className="table-gray">
                        <thead>
                            <tr>
                                <th style={{ width: '10%' }}>신청월</th>
                                <th style={{ width: '30%' }}>상품명</th>
                                <th style={{ width: '10%' }}>결제수단</th>
                                <th style={{ width: '10%' }}>결제금액</th>
                                <th style={{ width: '10%' }}>결제여부</th>
                                <th style={{ width: '10%' }}>결제건수</th>
                                <th style={{ width: '10%' }}>취소일</th>
                                <th style={{ width: '10%' }}>취소 사유</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataPayment && dataPayment.length > 0 ? (
                                dataPayment.map((item, index) => {
                                    const addDateFormated = item?.addDate
                                        ? moment(item?.addDate).format('YYYY-MM')
                                        : '';
                                    const paymentMethod = getPaymentMethod(item?.payMethod);
                                    const totPrice = formatNumberWithCommas(item?.totPrice);
                                    return (
                                        <tr key={'payment' + index}>
                                            <td>{addDateFormated}</td>
                                            <td>{item?.goodName}</td>
                                            <td>{paymentMethod}</td>
                                            <td>{totPrice}</td>
                                            <td>{item?.resultCode === '00' ? '결제완료' : '미결제'}</td>
                                            <td>1</td>
                                            <td>{item?.cancelFlag === 'N' ? '' : formatDate(item?.cancelDate)}</td>
                                            <td>{item?.cancelMsg}</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={8}>데이타가 없습니다.</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td />
                                <td />
                                <td>총 금액</td>
                                <td>{formatNumberWithCommas(totalTotPrice)}</td>
                                <td>결제완료</td>
                                <td>{formatNumberWithCommas(totalSuccessPayment)}</td>
                                <td>결제취소</td>
                                <td>{formatNumberWithCommas(totalCancel)}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div id="profile-paid-banners">
                    <div className="title-table">
                        등록(예정)중인 유료 배너{' '}
                        <small className="blue">*자세한 사항은 배너 등록 내역 메뉴에서 확인</small>
                    </div>
                    <table className="table-gray">
                        <thead>
                            <tr>
                                <th style={{ width: '40%' }}>신청상품</th>
                                <th style={{ width: '20%' }}>신청기간</th>
                                <th style={{ width: '10%' }}>S/V일수</th>
                                <th style={{ width: '10%' }}>입금여부</th>
                                <th style={{ width: '10%' }}>상태</th>
                                <th style={{ width: '10%' }}>조회수</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataBanner && dataBanner.length > 0 ? (
                                dataBanner.map((item, index) => (
                                    <tr key={'banner' + index}>
                                        <td>{item?.goodName}</td>
                                        <td>{`${formatDate(item?.startDate)} ~ ${formatDate(item?.endDate)}`}</td>
                                        <td>{item?.duration}</td>
                                        <td>
                                            {`${item?.ipGumCheck === 'Y'
                                                ? `입금확인 (${formatDate(item?.ipGumCheckDate)})`
                                                : '입금미확인'
                                                } `}
                                        </td>
                                        <td>{item?.status}</td>
                                        <td>{item?.visiedCnt}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6}>데이타가 없습니다.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div id="profile-recent-recruitment">
                    <div className="title-table">최근 채용 광고</div>
                    <table className="table-gray">
                        <thead>
                            <tr>
                                <th style={{ width: '3%' }} />
                                <th style={{ width: '24%' }}>
                                    치과명
                                    <br />
                                    제목
                                    <br />
                                    상품
                                    <br />
                                    결제 방법
                                </th>
                                <th style={{ width: 'auto' }}>
                                    모집시작
                                    <br />
                                    모집종료
                                </th>
                                <th style={{ width: '13%' }}>
                                    강조/옵션시작
                                    <br />
                                    강조/옵션종료
                                </th>
                                <th style={{ width: '12%' }}>상태</th>
                                <th style={{ width: '8%' }}>프리미엄SV</th>
                                <th style={{ width: '6%' }}>조회</th>
                                <th style={{ width: '8%' }}>
                                    등록일
                                    <br />
                                    수정일
                                </th>
                                <th style={{ width: '8%' }}>
                                    마감(변경)일
                                    <br />
                                    잔여일
                                </th>
                                <th style={{ width: '11%' }}>관리</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataRecruit === null && dataRecruitHist === null ? (
                                <tr>
                                    <td colSpan={10}>데이타가 없습니다.</td>
                                </tr>
                            ) : (
                                (() => {
                                    const seenSeqs = new Set();
                                    const firstStatusFlags = new Map();
                                    return [...(dataRecruit || []), ...(dataRecruitHist || [])].map((item, index) => {
                                        const isDuplicate = seenSeqs.has(item.seq);
                                        if (!isDuplicate) {
                                            firstStatusFlags.set(item.seq, item.statusFlag);
                                        }
                                        seenSeqs.add(item.seq);
                                        const isFirstRecordClosed = ['C', 'D', 'E'].includes(
                                            firstStatusFlags.get(item.seq),
                                        );

                                        return (
                                            <tr key={'recruit' + index}>
                                                <td>{item.seq}</td>
                                                <td style={{ textAlign: 'start' }}>
                                                    <div>[ {item?.companyName} ]</div>
                                                    <div>{item?.title}</div>
                                                    {item?.goodName.split(',').map((itemGoodName, index) => (
                                                        <div style={{ color: 'blue' }} key={index}>
                                                            - {itemGoodName}
                                                        </div>
                                                    ))}
                                                    <div style={{ color: 'blue' }}>
                                                        [ {getPaymentMethod(item?.payMethod)} ]
                                                    </div>

                                                    {item?.couponNum !== '' && (
                                                        <div>
                                                            <br />
                                                            <span style={{ color: 'blue' }}>{item?.couponName}</span><br />
                                                            <span>쿠폰번호 : <span style={{ color: 'blue' }}>{item?.couponNum}</span></span><br />
                                                            <span>유효기간 : <span style={{ color: 'blue' }}>{item?.startDate} ~ {item?.expiryDate}</span></span><br />
                                                            <span>
                                                                상태 :
                                                                {item?.isUsed === 'N'
                                                                    ? (() => {
                                                                        const today = new Date();
                                                                        today.setHours(0, 0, 0, 0);

                                                                        const expiry = new Date(item?.expiryDate);
                                                                        expiry.setHours(0, 0, 0, 0);

                                                                        return expiry < today
                                                                            ? <span style={{ color: 'gray' }}>기간만료</span>
                                                                            : <span style={{ color: 'blue' }}>사용가능</span>;
                                                                    })()
                                                                    : <span style={{ color: 'red' }}>사용완료 (사용일자: {formatDate(item?.useDate)})</span>
                                                                }
                                                            </span>
                                                        </div>

                                                    )}
                                                </td>
                                                <td style={{ padding: '8px' }}>
                                                    {!isDuplicate ? (
                                                        <>
                                                            <div>{formatDate(item?.recruitFrom)}</div>
                                                            <div>{formatDate(item?.recruitEnd)}</div>
                                                        </>
                                                    ) : (
                                                        ''
                                                    )}
                                                </td>
                                                <td>
                                                    {item?.optTerm !== '' ? '(옵)' : ''}
                                                    <div>{formatDate(item?.optTerm.split('|')[1])}</div>
                                                    <div>{formatDate(item?.optTerm.split('|')[2])}</div><br />
                                                    {item?.extraTerm !== '' ? '(강)' : ''}
                                                    <div>{formatDate(item?.extraTerm.split('|')[1])}</div>
                                                    <div>{formatDate(item?.extraTerm.split('|')[2])}</div>
                                                </td>
                                                <td style={{ padding: '8px' }}>
                                                    <span
                                                        style={{
                                                            backgroundColor: selectStatusColor(
                                                                item?.statusFlag,
                                                                item?.recruitEnd,
                                                            ),
                                                            color: '#fff',
                                                            padding: '3px 10px',
                                                            borderRadius: '16px',
                                                        }}
                                                    >
                                                        {getStatusText(item?.statusFlag, item?.recruitEnd, item?.recruitFrom)}
                                                    </span>

                                                    {item?.statusFlag === 'O' ? (
                                                        <>
                                                            <p style={{ marginTop: '5px' }}>
                                                                {isValidDate(item?.viewOkDate) ? formatDateTime(item.viewOkDate) : ''}
                                                            </p>
                                                        </>
                                                    ) : (
                                                        ''
                                                    )}
                                                </td>
                                                <td></td>
                                                <td style={{ padding: '8px' }}>{item?.visitedCnt}</td>
                                                <td style={{ padding: '8px' }}>
                                                    <div>{isValidDate(item?.addDate) ? formatDate(item.addDate) : ''}</div>
                                                    <div>{isValidDate(item?.modDate) ? formatDate(item.modDate) : ''}</div>
                                                </td>
                                                <td style={{ padding: '8px' }}>
                                                    <div>
                                                        {item?.statusFlag === 'C' || item?.statusFlag === 'E' ? (
                                                            <>
                                                                <div>{formatDate(item?.modDate)}</div>
                                                                <div>
                                                                    {moment(item?.recruitEnd)
                                                                        .endOf('day')
                                                                        .diff(
                                                                            moment(item?.modDate).startOf('day'),
                                                                            'days',
                                                                        )}
                                                                </div>
                                                            </>
                                                        ) : (
                                                            formatDate(item?.changeDate)
                                                        )}
                                                    </div>
                                                </td>
                                                <td style={{ padding: '8px' }}>
                                                    <div className="button-flex">
                                                        {!isDuplicate && item?.statusFlag === 'O' && (
                                                            <div className="wrap-button">
                                                                <button
                                                                    onClick={() =>
                                                                        handleCancelRecruit(item.memberID, item.seq)
                                                                    }
                                                                >
                                                                    승인취소
                                                                </button>
                                                                <button
                                                                    onClick={() =>
                                                                        handleOpenPopup('popupMABAA080_1', {
                                                                            memberID: item.memberID,
                                                                            recruitSeq: item.seq,
                                                                            recruitFrom: item.recruitFrom,
                                                                            recruitEnd: item.recruitEnd,
                                                                        })
                                                                    }
                                                                >
                                                                    배너등록
                                                                </button>
                                                            </div>
                                                        )}
                                                        {!isDuplicate &&
                                                            (item?.statusFlag === 'O' ||
                                                                item?.statusFlag === 'V' ||
                                                                item?.statusFlag === 'P' ||
                                                                item?.statusFlag === 'W') && (
                                                                <>
                                                                    <div className="wrap-button">
                                                                        <button
                                                                            onClick={() =>
                                                                                handleOpenPopup('popupMABAA080_2', {
                                                                                    memberID: item.memberID,
                                                                                    recruitSeq: item.seq,
                                                                                    goodName: item.goodName,
                                                                                    recruitFrom: item.recruitFrom,
                                                                                    recruitEnd: item.recruitEnd,
                                                                                })
                                                                            }
                                                                        >
                                                                            수정/마감
                                                                        </button>

                                                                        <button
                                                                            onClick={() =>
                                                                                handleOpenPopup('popupMABAA080_3', {
                                                                                    memberID: item.memberID,
                                                                                    recruitSeq: item.seq,
                                                                                    goodName: item.goodName,
                                                                                    recruitFrom: item.recruitFrom,
                                                                                    recruitEnd: item.recruitEnd,
                                                                                })
                                                                            }
                                                                        >
                                                                            채용추가
                                                                        </button>
                                                                    </div>
                                                                    <div className="wrap-button">
                                                                        <button
                                                                            onClick={() =>
                                                                                handleOpenPopup('popupMABAA080_4', {
                                                                                    memberID: item.memberID,
                                                                                    recruitSeq: item.seq,
                                                                                    recruitFrom: item.recruitFrom,
                                                                                    recruitEnd: item.recruitEnd,
                                                                                    title: item.title,
                                                                                })
                                                                            }
                                                                        >
                                                                            강조추가
                                                                        </button>
                                                                        <button
                                                                            onClick={() =>
                                                                                handleOpenPopup('popupMABAA080_5', {
                                                                                    memberID: item.memberID,
                                                                                    recruitFrom: item.recruitFrom,
                                                                                    recruitEnd: item.recruitEnd,
                                                                                    recruitSeq: item.seq,
                                                                                    title: item.title,
                                                                                })
                                                                            }
                                                                        >
                                                                            옵션추가
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}
                                                        {!isDuplicate &&
                                                            (item?.statusFlag === 'C' ||
                                                                item?.statusFlag === 'D' ||
                                                                item?.statusFlag === 'E') && (
                                                                <>
                                                                    <div className="wrap-button">
                                                                        <button
                                                                            onClick={() =>
                                                                                handleOpenPopup('popupMABAA080_6', {
                                                                                    memberID: item.memberID,
                                                                                    recruitSeq: item.seq,
                                                                                    title: item.title,
                                                                                })
                                                                            }
                                                                        >
                                                                            광고등록
                                                                        </button>
                                                                        <button
                                                                            onClick={() =>
                                                                                handleOpenPopup('popupMABAA080_7', {
                                                                                    memberID: item.memberID,
                                                                                    recruitSeq: item.seq,
                                                                                    goodName: item.goodName,
                                                                                    paySeq: item.paySeq,
                                                                                })
                                                                            }
                                                                        >
                                                                            재사용
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}
                                                        {isDuplicate &&
                                                            item?.extraTerm !== '' &&
                                                            !isFirstRecordClosed && (
                                                                <div className="wrap-button">
                                                                    <button
                                                                        onClick={() =>
                                                                            handleOpenPopup('popupMABAA080_9', {
                                                                                memberID: item.memberID,
                                                                                recruitSeq: item.seq,
                                                                                title: item.title,
                                                                                recruitFrom: item.recruitFrom,
                                                                                recruitEnd: item.recruitEnd,
                                                                                extraSeq: item.extraSeq,
                                                                                goodCode: item.goodNameCode,
                                                                                extraTerm: item.extraTerm,
                                                                            })
                                                                        }
                                                                    >
                                                                        수정/마감
                                                                    </button>
                                                                </div>
                                                            )}
                                                        {isDuplicate &&
                                                            item?.optTerm !== '' &&
                                                            !isFirstRecordClosed && (
                                                                <div className="wrap-button">
                                                                    <button
                                                                        onClick={() =>
                                                                            handleOpenPopup('popupMABAA080_8', {
                                                                                memberID: item.memberID,
                                                                                recruitSeq: item.seq,
                                                                                title: item.title,
                                                                                recruitFrom: item.recruitFrom,
                                                                                recruitEnd: item.recruitEnd,
                                                                                extraSeq: item.extraSeq,
                                                                                goodCode: item.goodNameCode,
                                                                                optTerm: item.optTerm,
                                                                            })
                                                                        }
                                                                    >
                                                                        수정/마감
                                                                    </button>
                                                                </div>
                                                            )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    });
                                })()
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {ActivePopup && (
                <ActivePopup
                    additionalData={isPopupOpen.additionalData}
                    isPopupOpen={isPopupOpen}
                    onClose={() => setIsPopupOpen(null)}
                />
            )}
        </>
    );
};
export default MABAA080;
